import request from '@/axios/http'


export function bannerApi (data) {
	return request({
		url: '/stage-api/lottery/banner/list',
		method: 'get',
		data
	})
}

export function help (data) {
	return request({
		// url: '/stage-api/help',
		url: '/stage-api/pre/center/list',
		method: 'get',
		data
	})
}
export function notice (data) {
	return request({
		url: '/stage-api/cms/pre_notice/notice_list',
		method: 'get',
		data
	})
}
// 首页 ranking/forecast 接口：后台为重查询，首次慢、缓存后快。前端两层优化：
// 1) 飞行中去重：相同参数在请求返回前只真正发一次，多个调用方共享同一 Promise（如预取与懒加载组件同参）；
// 2) 短 TTL 缓存：相同参数在缓存有效期内直接返回，不再请求后台，让"首屏预取的冷查询结果"被后续
//    滚动到时的懒加载组件命中秒回，避免用户滚动时撞上首次冷查询（会卡）。
// ranking/forecast 为非实时数据，2 分钟延迟可容忍；不同参数（如切换 ranking 标签）按 key 区分正常发新请求。
const rankingInflight = new Map()
const rankingCache = new Map() // key -> { expire, data }
const RANKING_TTL = 120 * 1000
export function queryPreRankingList (data) {
	const key = JSON.stringify(data || {})
	const now = Date.now()
	const cached = rankingCache.get(key)
	if (cached && cached.expire > now) {
		return Promise.resolve(cached.data)
	}
	if (rankingInflight.has(key)) return rankingInflight.get(key)
	const p = request({
		url: '/stage-api/pre/record/queryPreRankingList',
		method: 'post',
		data,
		// 后台重查询，首屏冷查询可能 >30s（其他接口仍用全局 30s 默认超时）；
		// 单独放宽到 90s，避免前端提前断连把"正在算的慢查询"砍成接口超时。
		timeout: 90000,
	}).then(res => {
		rankingCache.set(key, { expire: Date.now() + RANKING_TTL, data: res })
		return res
	}).finally(() => {
		rankingInflight.delete(key)
	})
	rankingInflight.set(key, p)
	return p
}
